export const setControlLimits = (
  control,
  { minDistance, maxDistance, minMaxAzimuthAngle, minMaxPolarAngle } = {
    minDistance: 0,
    maxDistance: Infinity,
    minMaxAzimuthAngle: Infinity,
    minMaxPolarAngle: Infinity,
  }
) => {
  control.minDistance = control.distance - minDistance;
  control.maxDistance = control.distance + maxDistance;

  control.maxAzimuthAngle = control.azimuthAngle + minMaxAzimuthAngle;
  control.minAzimuthAngle = control.azimuthAngle - minMaxAzimuthAngle;
  control.maxPolarAngle = control.polarAngle + minMaxPolarAngle;
  control.minPolarAngle = control.polarAngle - minMaxPolarAngle;
};
